var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"whatsapp-icon",attrs:{"fab":"","bottom":"","right":"","fixed":""},on:{"click":_vm.redirectToWhatsapp}},[_c('v-icon',[_vm._v("mdi-whatsapp")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }